import moment from 'moment';
import { Box, Text } from 'atoms';

const DateFormat = 'DD-MM-YYYY';
// const TIME_FORMAT = 'hh:mm a';

function getLocalDate(date) {
	// console.log(moment(date).add(330, 'minutes').format(DateFormat));
	// console.log(moment.utc(date, 'MM/DD/YYYY HH:mm').toDate());

	if (date) {
		return moment(date).add(330, 'minutes').format(DateFormat);
	}
	return '';
}

// function getLocalTime(time) {
// 	if (time) {
// 		return moment(time).add(330, 'minutes').format(TIME_FORMAT);
// 	}
// 	return '';
// }

export const AirExpensesTableConfig = [
	{
		title: 'AWB',
		dataIndex: 'awb_no',
		key: 'awb_no',
		hidden: false,
		width: '8%',
		render: (awb_no) => <Text overFlow="hidden">{awb_no || ''}</Text>,
	},
	{
		title: 'Transaction Date',
		dataIndex: 'transaction_date',
		key: 'transaction_date',
		width: '8%',
		hidden: false,
		render: (transaction_date, record) => (
			<Box>
				<Text overFlow="hidden">{getLocalDate(record?.transaction_date)}</Text>{' '}
			</Box>
		),
	},
	{
		title: 'Source',
		dataIndex: 'source',
		key: 'source',
		hidden: false,
		width: '5%',
		render: (source) => <Text overFlow="hidden">{source || ''}</Text>,
	},
	{
		title: 'Destination',
		dataIndex: 'destination',
		key: 'destination',
		width: '5%',
		hidden: false,
		render: (destination) => <Text overFlow="hidden">{destination || ''}</Text>,
	},
	{
		title: 'Net Amount',
		dataIndex: 'net_amount',
		key: 'net_amount',
		width: '10%',
		hidden: false,
		render: (net_amount) => <Text overFlow="hidden">{net_amount || ''}</Text>,
	},
	{
		title: 'Client Net Amount',
		dataIndex: 'client_net_amount',
		key: 'client_net_amount',
		width: '10%',
		hidden: false,
		render: (client_net_amount) => <Text overFlow="hidden">{client_net_amount || ''}</Text>,
	},
];
